// extracted by mini-css-extract-plugin
export var addButton = "_g0-0";
export var border = "_g0-8";
export var check = "_g0-h";
export var danger = "_g0-6";
export var dropdownContainer = "_g0-1";
export var editModalBody = "_g0-j";
export var footerContainer = "_g0-i";
export var fullWidth = "_g0-a";
export var hide = "_g0-9";
export var icon = "_g0-3";
export var input = "_g0-7";
export var inputFlex = "_g0-b";
export var inputWrapper = "_g0-c";
export var manualFocus = "_g0-5";
export var optionButton = "_g0-4";
export var pillWrapper = "_g0-e";
export var pointer = "_g0-2";
export var showOverflow = "_g0-f";
export var tagsFlex = "_g0-d";
export var xButton = "_g0-g";